module.exports = __webpack_public_path__ + "static/media/TC.d748d689.svg";